var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseHeaderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2629 16.0004L25.1316 9.13164C25.7566 8.50664 25.7566 7.49414 25.1316 6.86914C24.5066 6.24414 23.4941 6.24414 22.8691 6.86914L16.0004 13.7379L9.13164 6.86914C8.50664 6.24414 7.49414 6.24414 6.86914 6.86914C6.24414 7.49414 6.24414 8.50664 6.86914 9.13164L13.7379 16.0004L6.86914 22.8691C6.24414 23.4941 6.24414 24.5066 6.86914 25.1316C7.18164 25.4441 7.59102 25.6004 8.00039 25.6004C8.40977 25.6004 8.81914 25.4441 9.13164 25.1316L16.0004 18.2629L22.8691 25.1316C23.1816 25.4441 23.591 25.6004 24.0004 25.6004C24.4098 25.6004 24.8191 25.4441 25.1316 25.1316C25.7566 24.5066 25.7566 23.4941 25.1316 22.8691L18.2629 16.0004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseHeaderIcon);
export default __webpack_public_path__ + "static/media/close-header-icon.6d4ac55f894f2adfcd50a9160a5e0e55.svg";
export { ForwardRef as ReactComponent };